export default "__VITE_ASSET__DhJhCLVh__"